import React, { ReactElement } from 'react';
import { Logo, Spinner } from '@feast-it/ui/light';

import {
  ButtonContainer,
  LayoutSkeletonCircle,
  LayoutSkeletonWrapper,
  SpinnerWrapper,
  StyledSkeletonText,
  StyledSkeletonLoaderButton,
} from './Layout.styled';
import { ThemeWrapperUI } from '../../components/ThemeWrapperUI';

export function LayoutSkeleton(): ReactElement {
  return (
    <ThemeWrapperUI>
      <LayoutSkeletonWrapper>
        <Logo name="Togather" fill="black" width="140px" />

        <LayoutSkeletonCircle width={40} />

        <ButtonContainer>
          <StyledSkeletonText height={20} rows={1} />

          <StyledSkeletonText height={20} rows={1} />

          <StyledSkeletonText height={20} rows={1} />

          <StyledSkeletonLoaderButton width={80} />

          <StyledSkeletonLoaderButton width={80} />
        </ButtonContainer>
      </LayoutSkeletonWrapper>

      <SpinnerWrapper>
        <Spinner size={100} color="mediumBlue" />
      </SpinnerWrapper>
    </ThemeWrapperUI>
  );
}
